export enum DeliveryMethod {
  AsperaP2P = "AsperaP2P",
  AsperaFaspex = "AsperaFaspex",
  AsperaPush = "AsperaPush",
  FTP = "FTP",
  SigniantP2P = "SigniantP2P",
  UNC = "UNC",
  AsperaDropbox = "AsperaDropbox",
  AsperaP2PWithSSHKey = "AsperaP2PWithSSHKey",
  AmazonS3Upload = "AmazonS3Upload",
  AsperaShares = "AsperaShares",
  Http = "Http",
  SFTP = "SFTP",
  SFTPWithSSHKey = "SFTPWithSSHKey",
  MailAttachment = "MailAttachment",
}
